"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineChartDynamicContext = exports.LineChartDynamicContext = exports.useLineChartStaticContext = exports.LineChartStaticContext = void 0;
const react_1 = require("react");
exports.LineChartStaticContext = (0, react_1.createContext)(undefined);
const useLineChartStaticContext = () => {
    const context = (0, react_1.useContext)(exports.LineChartStaticContext);
    if (!context) {
        throw new Error('useLineChartStaticContext must be used within LineChartProvider');
    }
    return context;
};
exports.useLineChartStaticContext = useLineChartStaticContext;
exports.LineChartDynamicContext = (0, react_1.createContext)(undefined);
const useLineChartDynamicContext = () => {
    const context = (0, react_1.useContext)(exports.LineChartDynamicContext);
    if (!context) {
        throw new Error('useLineChartDynamicContext must be used within LineChartProvider');
    }
    return context;
};
exports.useLineChartDynamicContext = useLineChartDynamicContext;
